import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Form, actions } from 'react-redux-form';
import { Link } from 'react-router-dom';
import Currency from '../Currency';
import { myIPOAccountID } from './utils';
import {
  baseTransferFundsPath,
  transferFundsPath,
} from '../Forms/Schemas/baseRrf';

import BaseDetailScreen from '../BaseDetailScreen';
import Button from '../Button';

import {
  addNotification,
} from '../../actions/notifications';

import {
  transferFundsDeposit,
  transferFundsWithdrawal,
  fetchAccountCashBalanceWithOfferingOrders,
} from '../../actions';

import './styles.css';

export const exceedsACHLimit = message => (
  <div styleName="exceedsLimit">
    { message }
    &nbsp;You may also transfer funds through a&nbsp;
    <Link to="/transfer-instructions/check">
      check deposit
    </Link>
    &nbsp;or&nbsp;
    <Link to="/transfer-instructions/wire">
      wire transfer
    </Link>
    .
  </div>
);

export const errorCodes = {
  'transaction.deposit.account.limit.has.been.reached': exceedsACHLimit('Your monthly deposit limit has been reached.'),
  'transaction.withdrawal.account.limit.has.been.reached': exceedsACHLimit('Your monthly withdrawal limit has been reached.'),
};

class UnconnectedTransferReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
  }
  onSubmit = async () => {
    this.setState({ submitting: true });
    try {
      const {
        accountNumber,
        transferFundsInfo,
        onNext,
      } = this.props;
      const {
        TransferAmount,
        accounts,
      } = transferFundsInfo;
      const {
        From,
        To,
      } = accounts;
      const strTrns = String(TransferAmount);
      if (From === myIPOAccountID) {
        await this.props.transferFundsWithdrawal(accountNumber, strTrns, To);
        await this.props.fetchAccountCashBalanceWithOfferingOrders(accountNumber, true);
      } else {
        await this.props.transferFundsDeposit(accountNumber, strTrns, From);
      }
      await this.props.resetTransferInfo();
      await this.props.resetTransferForm();
      onNext();
    } catch (err) {
      if (err.res) {
        const { errors } = await err.res.json();
        if (errors && errors.length && errors.length > 0) {
          errors.forEach((error) => {
            let notification = error.message || errorCodes[error.errorCode];

            // test if attempt returns error about maximum transfer limit
            // if so we should direct the user to check deposit or wire transfer
            // instructions
            if (error.type === 'VALIDATION_RULE') {
              if (error.message && error.message.includes('Error: amount:')) {
                notification = exceedsACHLimit('The requested deposit amount exceeds our ACH limits.');
              }
            }
            return this.props.addNotification(notification);
          });
        } else {
          this.props.addNotification(`Error response from server: ${
            (errors && errors.validationErrors && JSON.stringify(errors.validationErrors, null, 2))}`);
        }
      } else {
        this.props.addNotification('Unknown error');
      }
      this.setState({ submitting: false });
    }
  }
  render() {
    const {
      backTo,
      transferFundsInfo,
    } = this.props;
    const {
      submitting,
    } = this.state;
    return (
      <BaseDetailScreen
        backLabel="Edit Transfer"
        backTo={backTo}
        pageHeading="Review Transfer"
      >
        <div styleName="transferReview">
          <div styleName="reviewLabels">From</div>
          <div styleName="reviewFields">{transferFundsInfo.fromLabel}</div>
          <div styleName="reviewLabels">To</div>
          <div styleName="reviewFields">{transferFundsInfo.toLabel}</div>
          <div styleName="reviewLabels">Transfer Amount</div>
          <Currency styleName="reviewAmount" amount={transferFundsInfo.TransferAmount} />
          <Form
            onSubmit={this.onSubmit}
            model={baseTransferFundsPath}
          >
            <div styleName="submitBtn">
              <Button disabled={submitting} type="submit">Submit</Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
  }
}


UnconnectedTransferReview.propTypes = {
  backTo: PropTypes.string,
  accountNumber: PropTypes.string,
};

UnconnectedTransferReview.defaultProps = {
  backTo: '',
  accountNumber: 'unknown',
};

const mapStateToProps = (state, props) => ({
  accountBankLinks: get(state, `accountBankLinks.[${props.accountNumber}].data`, []),
  transferFundsInfo: get(state, 'transferFundsInfo.transferInfo'),
});

const mapDispatchToProps = dispatch => ({
  transferFundsDeposit: (...args) => (dispatch(transferFundsDeposit(...args))),
  transferFundsWithdrawal: (...args) => (dispatch(transferFundsWithdrawal(...args))),
  addNotification: (...args) => (dispatch(addNotification(...args))),
  resetTransferInfo: () => (dispatch(actions.reset(transferFundsPath))),
  resetTransferForm: () => (dispatch(actions.reset(baseTransferFundsPath))),
  fetchAccountCashBalanceWithOfferingOrders: (...args) =>
    (dispatch(fetchAccountCashBalanceWithOfferingOrders(...args))),
});


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedTransferReview);



// WEBPACK FOOTER //
// ./src/components/TransferFunds/TransferReview.js